// root state object.
// each Vuex instance is just a single state tree.
const state = {
  demoScrollTop: 0
}

// mutations are operations that actually mutates the state.
// each mutation handler gets the entire state tree as the
// first argument, followed by additional payload arguments.
// mutations must be synchronous and can be recorded by plugins
// for debugging purposes.
const mutations = {
  updateDemoPosition (state, payload) {
    state.demoScrollTop = payload.top
  }
}

// actions are functions that causes side effects and can involve
// asynchronous operations.
const actions = {
  updateDemoPosition ({commit}, top) {
    commit({type: 'updateDemoPosition', top: top})
  }
}

// getters are functions
const getters = {

}


// A Vuex instance is created by combining the state, mutations, actions,
// and getters.
export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/vux.js